import { useAppDispatch } from '../../../../store/store';
import { ePartyPurpose } from '../../../../ui-toolkit/enums/ePartyPurpose';
import React, { useState } from 'react';
import { SelectDocuments } from './SelectDocuments';
import { useSelectCurrentOrder } from '../../../../selectors/order/selectCurrentOrder';
import { useFormikContext } from 'formik';
import { IMergeDocumentValues } from './MergeDocumentForm';
import { isMergeableDocument } from './mergeDocumentSchema';
import { downloadDocument } from 'API/order/documents/downloadDocument';
import { IStandardDocumentVersionData } from 'types/order/documents/shared/interfaces';
import { getAdminDocuments } from '../../../../store/order/documents/adminDocuments/dispatch';
import { eTransactionCategory } from '../../../../ui-toolkit/enums/eTransactionType';
import { checkForMutationSuccess } from '../../../../API/checkForMutationSuccess';
import { useGeneratePackageMutation } from '../../../../API/order/documents/DocumentPackageAPI';

export interface ISelectDocumentsContainerProps {
  documents: IStandardDocumentVersionData[];
  orderId: string;
  searchValue: string | null;
  setSearchValue: (val: string | null) => void;
  setShowAddDocumentModal: (show: boolean) => void;
}

export const SelectDocumentsContainer: React.FC<ISelectDocumentsContainerProps> = ({
  documents,
  orderId,
  searchValue,
  setSearchValue,
  setShowAddDocumentModal,
}) => {
  const dispatch = useAppDispatch();
  const { data: order } = useSelectCurrentOrder();
  const transactionType: eTransactionCategory = order.transaction.transaction_category;
  const [generatePackageMutation, { isLoading: isAffidavitGenerating, error: generateAffidavitError }] =
    useGeneratePackageMutation();
  const formik = useFormikContext<IMergeDocumentValues>();
  const [showAffidavitResultModal, setShowAffidavitResultModal] = useState(false);

  const onClick = () => {
    formik.setFieldTouched('showModal');
    formik.setFieldValue('showModal', true);
  };

  const onDownloadClick = () => {
    formik.values.selectedDocuments.forEach((doc) => {
      downloadDocument(doc.id, doc.versionId, doc.fileName);
    });
  };

  const disableDownload = formik.values.selectedDocuments.length < 2;

  const disableCombineDocs =
    formik.values.selectedDocuments.length < 2 ||
    formik.values.selectedDocuments.some((doc) => !isMergeableDocument(doc.fileName));

  const onModalClose = () => {
    dispatch(getAdminDocuments(orderId));
  };

  const onGenerateAffidavits = async (party: ePartyPurpose) => {
    try {
      const result = await generatePackageMutation({ orderId, packageType: `legacy-${party}-affidavit` });
      if (checkForMutationSuccess(result, `sending ${party} affidavit generation request`)) {
        setShowAffidavitResultModal(true);
      }
    } catch (e) {}
  };

  return (
    <SelectDocuments
      affidavitGenerating={isAffidavitGenerating}
      affidavitGeneratingFailed={!!generateAffidavitError}
      documents={documents}
      onClick={onClick}
      disableCombineDocs={disableCombineDocs}
      disableDownload={disableDownload}
      onDownloadClick={onDownloadClick}
      onGenerateAffidavits={onGenerateAffidavits}
      onModalClose={onModalClose}
      orderId={orderId}
      searchValue={searchValue}
      setSearchValue={setSearchValue}
      setShowAddDocumentModal={setShowAddDocumentModal}
      showAffidavitResultModal={showAffidavitResultModal}
      transactionType={transactionType}
    />
  );
};
